import { action, ActionMessage } from 'satcheljs';

export const satchelActionDispatched = action(
    '__DIAGNOSTICS_SATCHEL_ACTION_DISPATCHED',
    (action: ActionMessage) => ({ name: action.type, payload: action.payload })
);
